import axios from 'axios';

class LocationsService {
  async getLocations(api1Origin: string, accessToken: string) {
    try {
      const response = await axios.get(`${api1Origin}/api2/getlocations`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.data) {
        return [];
      }
      const locations = response.data;
      return locations;
    } catch (error) {
      console.log('Error fetching locations: ', error);
      return [];
    }
  }
}

export const locationsService = new LocationsService();
